import { render, staticRenderFns } from "./asset-grid.vue?vue&type=template&id=08d817bc&scoped=true&"
import script from "./asset-grid.vue?vue&type=script&lang=ts&"
export * from "./asset-grid.vue?vue&type=script&lang=ts&"
import style0 from "./asset-grid.vue?vue&type=style&index=0&id=08d817bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d817bc",
  null
  
)

export default component.exports